export default class FormHelper {
    public static getValidationErrors(validationState: any): any[] {
        let validationErrors: any[] = [];

        for (var propertyName in validationState) {
            if (validationState.hasOwnProperty(propertyName)) {
                for (let message of validationState[propertyName]) {
                    validationErrors.push({ name: propertyName, message: message });
                }
            }
        }

        return validationErrors;
    }

    public static isControlValidationError(controlName: string, validationErrors: any[]): boolean {
        return validationErrors.filter(x => x.name === controlName).length > 0;
    }

    public static getRequestVerificationToken(): string {
        return (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
    }

    public static showPassword(inputId: string) {
        let input: HTMLElement = document.querySelector("#" + inputId);
        input.setAttribute("type", input.getAttribute("type") === "password" ? "text" : "password");
    }

    static setFocus(contextElement: HTMLElement) {
        // Set focus on first input element
        let firstInput = contextElement.querySelector("input");
        if (firstInput) {
            firstInput.focus();
        }
    }

    static removeFocus() {
        // Remove document focus
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }

    // Legacy
    public static setValidation($context, validationState: any) {
        $context = $context || $("body");
        var $validationSummary = $("[data-valmsg-summary]", $context);
        $validationSummary.addClass("validation-errors").removeClass("validation-valid");
        var ul = $("ul", $validationSummary).empty();

        let validationErrors = this.getValidationErrors(validationState);

        for (const validationError of validationErrors) {
            ul.append("<li>" + validationError.message + "</li>");

            $context.find("*[data-valmsg-for='" + validationError.name + "'],*[data-valmsg-for='" + validationError.name + "']").html(validationError.message).addClass("field-validation-error");
            $context.find("*[name='" + validationError.name + "'],*[name='" + validationError.name + "']").addClass("input-validation-error-legacy");
        }
    }

    // Legacy
    public static resetValidation($context) {
        $context = $context || $("body");
        var $validationSummary = $("[data-valmsg-summary]", $context);
        $validationSummary.addClass("validation-errors").removeClass("validation-errors");
        var ul = $("ul", $validationSummary).empty();
        $(".field-validation-error", $context).addClass("field-validation-valid").removeClass("field-validation-error").empty();
        $(".input-validation-error-legacy", $context).addClass('input-validation-valid').removeClass("input-validation-error-legacy");
    };

    // Legacy
    public static disableControls($context) {
        $context = $context || $("body");
        var $disableOnSubmit = $(".disable-on-submit", $context);
        $disableOnSubmit.attr("disabled", "disabled");
    }

    // Legacy
    public static enableControls($context) {
        var $context = $context || $("body");
        var $disableOnSubmit = $(".disable-on-submit", $context);
        $disableOnSubmit.removeAttr("disabled");
    }
}